import {inject, Injectable, runInInjectionContext}                                                     from '@angular/core';
import {Timestamp}                                                                                     from '@angular/fire/firestore';
import {Functions, httpsCallable}                                                                      from '@angular/fire/functions';
import {CrudPathDict, DuplicateImageInput, DuplicateImageResult, FoodRecordLogIntf, FoodRecordSumIntf} from '@djsharkk/logr-types';
import {DataFirebaseBase}                                                                              from './data-firebase.base';


@Injectable({
				providedIn: 'root'
			})
export class DataFoodService extends DataFirebaseBase<FoodRecordLogIntf, FoodRecordSumIntf> {
	protected paths: CrudPathDict = {
		log: 'food_records_log',
		sum: 'food_records_sum'
	};


	async duplicateFoodRecord(record: FoodRecordLogIntf) {
		const {destinationPath} = (await this.duplicateImage(record.image)).data;
		if (!destinationPath) {
			throw new Error('Failed to duplicate image file')
		}

		await this.svcFirebaseTools.recCreate<FoodRecordLogIntf>(
			'food_records_log',
			{
				...record,
				image    : destinationPath,
				timestamp: Timestamp.now()
			}
		)

	}


	async duplicateImage(sourcePath: string) {
		return await runInInjectionContext(this.injector, async () => {
			const functions = inject(Functions)
			const getData = httpsCallable<DuplicateImageInput, DuplicateImageResult>(functions, 'duplicateFoodImage');
			return getData({
							   sourcePath
						   });
		})
	}


}
